import { IconButton, IconButtonProps, styled } from '@mui/material';
import { SVGProps } from 'react';

import { ReactComponent as Document } from 'assets/icons/document.svg';

interface MenuButtonProps extends IconButtonProps {
	language: string;
}

interface DocumentIconProps extends SVGProps<SVGSVGElement> {
	choosedfile: boolean;
}

export const MenuButton = styled(IconButton)<MenuButtonProps>(({ language, disabled }) => ({
	position: 'absolute',
	top: '2px',
	right: language == 'ar' ? 'unset' : '5px',
	left: language == 'ar' ? '5px' : 'unset',
	cursor: disabled ? 'default' : 'pointer',

	'& svg path': {
		fill: '#B7BCC6',
	},
}));

export const DocumentIcon = styled(Document)<DocumentIconProps>(({ choosedfile }) => ({
	'& path': {
		fill: choosedfile ? '#4786FF' : '#B7BCC6',
	},
}));
